import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { getRouteConfigByPath } from '@hotjar/webapp/utils/routing';

import { NewNavRouted } from './NewNavRouted';

const InternalNav = (): JSX.Element => {
  const { pathname } = useLocation();
  const routeConfig = getRouteConfigByPath(pathname);

  const hasRouteConfig = routeConfig !== undefined;

  return <NewNavRouted hasRouteConfig={hasRouteConfig} />;
};

export const Nav = memo(InternalNav);
